import React from 'react';
import { useTranslation } from '../hx/useTranslation';
import * as FxFetch from '../fx/FxFetch';
import * as FxLog from '../fx/FxLog';
import * as FxTable from '../fx/FxTable';
import * as FxNum from '../fx/FxNum';
import CxTable from '../cx/CxTable';
import CxHr from '../cx/CxHr';
import CxSnackbar from '../cx/CxSnackbar';
import CxLink from '../cx/CxLink';
import { useSessionStorage } from '../hx/useSessionStorage';
import { StoreClient, StoreSlsAux, StoreSlsLst, StoreSlsDoc, clearStore, isApp, } from "./GxStore";
import { useNav } from '../hx/useNav';
import { useWindowSize } from '../hx/useWindowSize';
import { useLocation } from 'react-router-dom';


const GxSlsAuxTable = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();
  const { state } = useLocation(); //captura los parámetros de navBack()
  const size = useWindowSize();

  const [storeClient,] = useSessionStorage('StoreClient', StoreClient);
  const [storeSlsAux, setStoreSlsAux] = useSessionStorage('StoreSlsAux', StoreSlsAux);
  const [storeSlsLst, setStoreSlsLst] = useSessionStorage('StoreSlsLst', StoreSlsLst);
  const [storeSlsDoc, setStoreSlsDoc] = useSessionStorage('StoreSlsDoc', StoreSlsDoc);

  const rf_table_pss = React.useRef(null);
  const r_snack_ask_save = React.useRef(null);

  const [txLinkAuxTable, setTxLinkAuxTable] = React.useState(props.txLinkAuxTable);
  const [txLinkAuxId, setTxLinkAuxId] = React.useState(props.txLinkAuxId);

  const [linkCopyToSalesDisabled, setLinkCopyToSalesDisabled] = React.useState(false);

  const [total, setTotal] = React.useState(0.0);


  React.useEffect(() => {
    clearStore('StoreSlsAux', storeSlsAux);

    loadRates('cli', storeClient.inClient, storeClient.txClient);
    if ((isApp('vett') || isApp('spaw')) && storeClient.inAnimal) {
      loadRates('ani', storeClient.inAnimal, storeClient.txAnimal);
    }

    // eslint-disable-next-line
  }, []);

  React.useImperativeHandle(props.xref, () => {
    return {
      setTxLinkAuxTable, setTxLinkAuxId,
    };
  });

  const doCopyToSls = () => {
    let record = {};
    record['pageNo'] = '0';
    record['pageSize'] = '1000';

    record['filter'] = `n_invoice_item_x.txLinkAuxTable='${txLinkAuxTable}' and n_invoice_item_x.txLinkAuxId='${txLinkAuxId}'`;

    Promise.all([FxFetch.doJsonX("sls/aux", record)]).then((result) => {
      FxLog.infox("GxSlsAuxTable.doMoveToSls", "...result[0]:", result[0]);
      if (result[0]) {
        FxLog.infox("GxSlsAuxTable.doMoveToSls", "creando nuevo...");
        clearStore('StoreSlsLst', storeSlsLst);
        clearStore('StoreSlsDoc', storeSlsDoc);

        storeSlsLst.listType = 'i';
        storeSlsLst.listTypeBackground = 'var(--ibs_color_blue_light)';
        storeSlsLst.table = 'n_invoice';
        storeSlsLst.table_idField = 'inInvoice';
        storeSlsLst.table_txField = 'txInvoice';
        storeSlsLst.table_dtField = 'dtInvoice';
        storeSlsLst.table_item = 'n_invoice_item';
        storeSlsLst.table_item_idField = 'inInvoiceItem';
        storeSlsLst.table_paym_idField = 'inPayment';
        setStoreSlsLst(storeSlsLst);

        storeSlsDoc.boFirstRender = true;
        storeSlsDoc.boDataChanged = '0';
        storeSlsDoc.docType = 'i';
        storeSlsDoc.inXXX = null;

        storeSlsDoc.txLinkAuxTable = txLinkAuxTable; 
        storeSlsDoc.txLinkAuxId = txLinkAuxId; 

        storeSlsDoc.inClient = storeClient.inClient;
        storeSlsDoc.txClient = storeClient.txClient;
        if ((isApp('vett') || isApp('spaw'))) {
          storeSlsDoc.inAnimal = storeClient.inAnimal;
          storeSlsDoc.txAnimal = storeClient.txAnimal;
        }
        if (storeSlsDoc.inEmployee) {
          FxLog.infox("GxSlsAuxTable.doMoveToSls", "...rf_txEmployee.current.getVal():", props.rf_txEmployee.current.getVal());
          storeSlsDoc.inEmployee = props.rf_txEmployee.current.getKey();
          storeSlsDoc.txEmployee = props.rf_txEmployee.current.getVal();
        }

        // items
        var items = storeSlsDoc.arItems || [];
        for (let i = 0; i < result[0].length; i++) {
          var item = {
            idx: i,
            inXxxItemX: result[0][i].inInvoiceItemX, 
            inPs: result[0][i].inPs,
            txPs: result[0][i].txPs,
            txLotCode: hasLots(result[0][i].hasLots),

            nuFrequency: result[0][i].nuFrequency,

            nuQuantity: result[0][i].nuQuantity,
            nuPrice: result[0][i].nuPrice,
            nuTaxable: result[0][i].nuTaxable,
            nuTaxPerc: result[0][i].nuTaxPerc,
            nuTax: result[0][i].nuTax,
            nuDiscountPerc: result[0][i].nuDiscountPerc,
            nuDiscount: result[0][i].nuDiscount,
            nuAmount: result[0][i].nuAmount,

            txPsAlias: result[0][i].txPsAlias,
            txAlert: result[0][i].txAlert,
            txRemarks: result[0][i].txRemarks,
          };
          items.push(item);
          FxLog.infox('GxSlsAuxTable.doMoveToSls', '...item:', item);
        }
        storeSlsDoc.arItems = items;

        Promise.all([setStoreSlsDoc(storeSlsDoc)]).then((result) => {
          navTo("sls-doc-form");
        });
      }
    });
  }

  const hasLots = (psHasLots) => {
    if (psHasLots === '1') {
      /* DAQ 2022.05.11 - indica a MxSlsDocForm.doLots() que este ps está pendiente de añadir lote */
      return '**pending**';
    }
    return '';
  }

  const onFetchPs = (newPageNo) => {
    if (state && state.scroll === 'bottom') {
      window.scrollTo(0, document.body.scrollHeight);
    }
    setLinkCopyToSalesDisabled(rf_table_pss.current.isEmpty());
    if (newPageNo===0) {
      getTotal();
    }
  }

  const getTotal = () => {
    if (rf_table_pss.current.isEmpty()) return;
    let record = {};
    record['txLinkAuxTable'] = txLinkAuxTable; 
    record['txLinkAuxId'] = txLinkAuxId; 
    Promise.all([FxFetch.doJsonX('sls/aux/total', record)]).then((result) => {
      FxLog.infox('GxSlsAuxTable.getTotal', '...result[0].theValue:', result[0].theValue);
      setTotal(parseFloat(result[0].theValue));
    });
  }

  const openFormAuxItem = async (op, row) => {
    if (!txLinkAuxId) {
      r_snack_ask_save.current.setOpen(true);
    } else {
      if (row === null) {
        storeSlsAux.inInvoiceItemX = null;
      } else {
        storeSlsAux.inInvoiceItemX = row.original.inInvoiceItemX;
      }
      storeSlsAux.inClient = storeClient.inClient;
      storeSlsAux.txLinkAuxTable = txLinkAuxTable;
      storeSlsAux.txLinkAuxId = txLinkAuxId;
      Promise.all([setStoreSlsAux(storeSlsAux)]).then((result) => {
        navTo("sls-aux-item");
      });
    }
  }

  const loadRates = (who, inXXX, txXXX) => {
    try {
      let record = {};
      record['who'] = who;
      record['inXXX'] = inXXX;
      Promise.all([FxFetch.doJsonX(`sls/doc/rates`, record)]).then((result) => {
        if (result[0]) {
          var rates = [result[0]];
          storeSlsAux.arRates = rates;
        } else {
          storeSlsAux.arRates = '';
        }
        setStoreSlsAux(storeSlsAux);
      });

    } catch (error) {
      FxLog.errorx("GxSlsAuxTable.loadRates", error);
    }
  }

/* 
  const getTableItemColumns = () => {
    let cols = [];
    try {
      cols.push({ id: "inInvoiceItemX", Header: "ID", accessor: "inInvoiceItemX", show: false });
      cols.push({ id: "txPs", Header: trans('field.ps'), accessor: "txPs", width: '35%' });
      cols.push({ id: "txTypePsGroup", Header: trans('field.group'), accessor: "txTypePsGroup", width: '25%', show: size.isLarge });
      cols.push({ id: "txTypePsSubgroup", Header: trans('field.subgroup'), accessor: "txTypePsSubgroup", width: '25%', show: size.isLarge });
      cols.push({ id: "nuAmount", Header: trans('field.amount'), accessor: row => (FxTable.cellTo2r00(row["nuAmount"])), align: 'right', width: '15%' });
      
      cols.push({ id: "G", Header: "copied_to_sales", accessor: row => Boolean(row["inInvoice"]), show: false });

    } catch (error) {
      FxLog.errorx('GxSlsAuxTable.getTableItemColumns', error)
    }
    return cols;
  }
 */

  const getTableItemColumns = () => {
    let cols = [];
    cols.push({ id: "id1", Header: "ID", accessor: "idx", show: false });
    cols.push({ id: "id2", Header: "ID", accessor: `${storeSlsLst.table_item_idField}`, show: false });
    cols.push({ id: "fq", Header: trans('field.frequency'), accessor: row => FxTable.cellToInt(row["nuFrequency"]), align: 'right', show: false });
    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: "ps", Header: trans('field.ps'), accessor: "txPs", width: '40%' });
      cols.push({ id: "qy", Header: trans('field.quantity'), accessor: row => FxTable.cellTo2r00(row["nuQuantity"]), width: '12%', align: 'right' });
      cols.push({ id: "pr", Header: trans('field.price'), accessor: row => FxTable.cellTo2r00(row["nuPrice"]), width: '12%', align: 'right' });
      cols.push({ id: "dp", Header: trans('field.discount_perc'), accessor: row => FxTable.cellTo2r00(row["nuDiscountPerc"]), width: '12%', align: 'right' });
      cols.push({ id: "tp", Header: trans('field.tax_perc'), accessor: row => FxTable.cellTo2r00(row["nuTaxPerc"]), width: '12%', align: 'right' });
      cols.push({ id: "tot", Header: trans('field.total'), accessor: row => FxTable.cellTo2r00(row["nuAmount"]), width: '12%', align: 'right' });

    } else { // PANTALLA PEQUEÑA
      cols.push({ id: "ps", Header: trans('field.ps'), accessor: "txPs", width: '60%' });
      cols.push({ id: "qy", Header: trans('field.quantity'), accessor: row => FxTable.cellTo2r00(row["nuQuantity"]), width: '20%', align: 'right' });
      cols.push({ id: "tot", Header: trans('field.total'), accessor: row => FxTable.cellTo2r00(row["nuAmount"]), width: '20%', align: 'right' });
    }

    cols.push({ id: "G", Header: "copied_to_sales", accessor: row => Boolean(row["inInvoice"]), show: false });

    return cols;
  }

  return (
    <div style={{ margin: '20px var(--ibs_container_margin) 50px var(--ibs_container_margin)' }}>
      <CxHr title={trans('field.pss')} >
        <CxLink label={`[${trans('field.copy_to_x', 'field.sales').toUpperCase()}]`} style={{ margin: '0 0 0 1px', fontSize: '12px' }} onClick={doCopyToSls} disabled={linkCopyToSalesDisabled} />
      </CxHr>
      <CxTable
        xref={rf_table_pss}
        url="sls/aux"
        filter={`n_invoice_item_x.txLinkAuxTable='${txLinkAuxTable}' and n_invoice_item_x.txLinkAuxId='${txLinkAuxId}'`}
        onOpenForm={openFormAuxItem}
        onFetchPage={onFetchPs}
        hasButtonAdd={true}
        refColors={[
          'table_cell_color_green|' + trans('field.copied_to_x', 'field.sales'),
        ]}
        columns={getTableItemColumns()}
        addTableButtonsRight={
          <span style={{ color: 'var(--ibs_color_black)', height: '30px', fontSize: '14px', marginRight: '7px' }}>
            {`${trans('field.total')}: ${FxNum.toString(FxNum.to2r00(total))}`}
          </span>
        }
      />

      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />

    </div>
  );
}

export default GxSlsAuxTable;
